import DOMPurify from 'dompurify'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { useSearchParams } from 'react-router'
import { notifyError } from '@/services/sentry'

export function useTranslate() {
  const { i18n } = useTranslation()
  const copies = useAppSelector(
    (store) => store.settingsApi.copies.response.languages
  )

  const lang = i18n.language.toUpperCase()

  const [searchParams] = useSearchParams()

  function handleCopyKeys() {
    const showCopyKeys =
      searchParams.get('alojomora') === 'true' ||
      sessionStorage.getItem('alojomora') === 'true'
        ? true
        : false
    sessionStorage.setItem('alojomora', showCopyKeys.toString())
    return showCopyKeys
  }

  const showCopyKeys = handleCopyKeys()

  function replaceValues(
    input: string,
    values: { [key: string]: string }
  ): string {
    const regex = /{{(.*?)}}/g
    return input.replace(regex, (match: string, key: string) => {
      if (Object.prototype.hasOwnProperty.call(values, key)) {
        return values[key]
      } else {
        return ''
      }
    })
  }

  const translate = (key: string, values: { [key: string]: string } = {}) => {
    if (showCopyKeys) return key

    const copy = copies?.[lang]?.copies?.[key]

    if (copy !== undefined) {
      return DOMPurify.sanitize(replaceValues(copy, values))
    }

    notifyError('Copy not found: ' + lang + '-' + key)

    return key
  }

  return { translate }
}
